import { makeStyles } from '@material-ui/core/styles';

export const useFooterStyles = makeStyles(() => ({
  container: {
    width: '100%',
  },
  toolbar: {
    minHeight: '94px',
    color: '#FFFFFF',
    background: '#000000',
    display: 'flex',
    flexDirection: 'column',
    padding: (props) =>
      props.mobile ? '24px 12px 24px 12px' : '1% 20% 0% 20%',
    maxWidth: (props) => (props.mobile ? '100%' : '100%'),
  },
  appbar: {
    position: 'relative',
  },
  text: {
    color: '#9d9d9d',
    alignSelf: 'center',
    fontSize: '12px',
    textAlign: 'center',
  },
}));
